<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>2-Faktor-Bestätigung</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="dismiss(null)">Abbrechen</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <p class="hint">
        Ein Bestätigungscode wurde an die beiden konfigurierten Admin-2FA-E-Mails gesendet.
        Bitte Code eingeben, um die kritische Änderung freizugeben.
      </p>
      <ion-item>
        <ion-input
          v-model="code"
          label="Code"
          label-placement="stacked"
          type="text"
          inputmode="numeric"
          maxlength="6"
          placeholder="6-stelliger Code"
          autocomplete="one-time-code"
          @keyup.enter="confirm"
        />
      </ion-item>
      <p v-if="error" class="error">{{ error }}</p>
      <div class="actions">
        <ion-button expand="block" :disabled="!canConfirm || submitting" @click="confirm">
          Bestätigen
        </ion-button>
        <ion-button
          expand="block"
          fill="outline"
          :disabled="resending"
          @click="resend"
        >
          Code erneut senden
        </ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  IonItem,
  IonInput,
  modalController,
} from '@ionic/vue';

export default {
  name: 'StepUpCodeModal',
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonItem,
    IonInput,
  },
  props: {
    challengeId: { type: [Number, String], required: true },
    onResend: { type: Function, default: null },
  },
  data() {
    return {
      code: '',
      error: '',
      submitting: false,
      resending: false,
      activeChallengeId: this.challengeId,
    };
  },
  computed: {
    canConfirm() {
      return /^\d{6}$/.test(String(this.code || '').trim());
    },
  },
  methods: {
    dismiss(result) {
      modalController.dismiss(result);
    },
    confirm() {
      if (!this.canConfirm || this.submitting) return;
      this.submitting = true;
      this.dismiss({
        challengeId: this.activeChallengeId,
        otp: String(this.code).trim(),
      });
    },
    async resend() {
      if (!this.onResend || this.resending) return;
      this.resending = true;
      this.error = '';
      try {
        const nextId = await this.onResend(this.activeChallengeId);
        if (nextId) this.activeChallengeId = nextId;
        this.code = '';
      } catch (e) {
        this.error = e?.message || 'Erneutes Senden fehlgeschlagen.';
      } finally {
        this.resending = false;
      }
    },
  },
};
</script>

<style scoped>
.hint {
  margin: 0 0 16px;
  color: #555;
  line-height: 1.4;
}
.error {
  color: var(--ion-color-danger, #eb445a);
  margin: 8px 0 0;
}
.actions {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
